import { ApaduaAPI } from './ApaduaAPI';

export class UserAPI extends ApaduaAPI {
    resource: string = 'api/';

    sendValidationEmail(): Promise<Array<any>> {
        return this.post('send-validation-email/', {}) as any;
    }
}
